// Accordion for the son-faq widget (see Son_FAQ).
//
// MARKUP CONTRACT
//   <div class="son-faq">
//     <div class="son-faq__item is-collapsed" id="son-faq-{id}">
//       <button class="son-faq__question" aria-expanded="false" aria-controls="son-faq-answer-{id}">
//       <div class="son-faq__answer" id="son-faq-answer-{id}">…</div>
//     </div>
//   </div>
//
// Open/close animation is pure CSS; JS only toggles .is-collapsed and
// aria-expanded.

function bindFaqItems(root = document) {
    root.querySelectorAll('.son-faq__question').forEach((button) => {
        if (button.dataset.sonFaqReady) {
            return;
        }
        button.dataset.sonFaqReady = 'true';

        button.addEventListener('click', () => {
            const item = button.closest('.son-faq__item');
            const collapsed = item.classList.toggle('is-collapsed');
            button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
    });
}

document.addEventListener('DOMContentLoaded', () => bindFaqItems());

// re-bind after Elementor editor re-renders an element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            bindFaqItems($element[0] || document);
        });
    }
});
